// pages/TermsPage.jsx
import React from "react";

export default function TermsPage() {
  return (
    <div className="panel">
      <h2>Terms and Conditions</h2>
      <p>
        Welcome to <strong>Gluten Free Navigator</strong> (“we,” “our,” or “us”).
        These Terms and Conditions (“Terms”) govern your access to and use of
        our website <a href="https://gfnavigator.com">gfnavigator.com</a> (the “Site”)
        and related services (collectively, the “Service”).
        By creating an account or using our Service, you agree to these Terms.
        If you do not agree, please do not use the site.
      </p>

      <h3>1. About Us</h3>
      <p>
        Gluten Free Navigator is operated from California, USA.  
        You can reach us at{" "}
        <a href="mailto:contact@gfnavigator.com">contact@gfnavigator.com</a>.
      </p>

      <h3>2. Eligibility and Accounts</h3>
      <ul>
        <li>You must be at least 13 years old to use our Service.</li>
        <li>
          You agree to provide accurate information when creating an account, including
          your first and last name, valid email address, and optional ZIP code.
        </li>
        <li>
          You are responsible for maintaining the confidentiality of your login credentials
          and all activity under your account.
        </li>
        <li>
          We reserve the right to suspend or terminate your account for any violation of
          these Terms or misuse of the Service.
        </li>
      </ul>

      <h3>3. Description of Service</h3>
      <p>
        Gluten Free Navigator helps users discover gluten-friendly restaurants and
        eateries. We provide curated listings, maps, and filters to assist users
        in finding options that fit their needs.
      </p>
      <p>
        We strive for accuracy but cannot guarantee that all restaurant information
        (e.g., menu items, gluten-free claims, hours, or safety practices) is current or correct.
        Users should always confirm directly with restaurants before dining.
      </p>

      <h3>4. Payments and Subscriptions</h3>
      <p>
        Some features of our Service may require payment or a subscription.
        Payments are processed securely through <strong>Stripe</strong>.
        We do not store or have access to your payment card details.
      </p>
      <ul>
        <li>All fees are stated in U.S. dollars unless otherwise specified.</li>
        <li>Subscriptions renew automatically unless canceled before the renewal date.</li>
        <li>
          You can cancel at any time, and your access will continue through the end of
          the current billing period.
        </li>
      </ul>

      <h3>5. Acceptable Use</h3>
      <p>When using our Service, you agree not to:</p>
      <ul>
        <li>Use the Service for unlawful, fraudulent, or deceptive purposes;</li>
        <li>Scrape, crawl, spider, or access the website by any automated means, 
            including bots, scripts, or data-mining tools;</li>
        <li>Copy, reverse-engineer, or attempt to extract our data or source code;</li>
        <li>Post or transmit any harmful, defamatory, or misleading content;</li>
        <li>Attempt to gain unauthorized access to our systems or other user accounts;</li>
        <li>Interfere with or disrupt the integrity or performance of the Service.</li>
      </ul>
      <p>
        Automated use of the website or its data without written permission from
        Gluten Free Navigator is strictly prohibited.
      </p>

      <h3>6. Intellectual Property</h3>
      <p>
        All content, features, and functionality on this site — including text, graphics,
        logos, and code — are owned by Gluten Free Navigator or its licensors and are
        protected by copyright, trademark, and other laws.
      </p>
      <p>
        You may use the Service for personal, non-commercial purposes only.
        Reproduction or redistribution without written consent is prohibited.
      </p>

      <h3>7. Third-Party Services</h3>
      <p>
        Our Service uses third-party providers such as Google Analytics, Google Ads, and
        Stripe. These services may collect data as described in our{" "}
        <a href="/privacy">Privacy Policy</a>.  
        We are not responsible for the practices or content of third-party sites.
      </p>

      <h3>8. Disclaimer of Warranties</h3>
      <p>
        The Service is provided “as is” and “as available.”  
        We make no warranties or representations about the accuracy, reliability,
        or completeness of any content or restaurant information.
      </p>
      <p>
        We disclaim all warranties, express or implied, including but not limited to
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement.
      </p>

      <h3>9. Limitation of Liability</h3>
      <p>
        To the maximum extent permitted by law, Gluten Free Navigator and its
        affiliates will not be liable for any indirect, incidental, consequential,
        or punitive damages arising out of your use of or inability to use the Service.
      </p>
      <p>
        In no event shall our total liability exceed the amount you paid (if any) for
        using the Service during the previous twelve months.
      </p>

      <h3>10. Indemnification</h3>
      <p>
        You agree to indemnify and hold harmless Gluten Free Navigator, its officers,
        employees, and partners from any claims, damages, or losses arising out of your
        use of the Service or violation of these Terms.
      </p>

      <h3>11. Termination</h3>
      <p>
        We may suspend or terminate your account or access at any time for violating these
        Terms or engaging in misuse of the Service. Upon termination, your right to use
        the Service will immediately cease.
      </p>

      <h3>12. Governing Law</h3>
      <p>
        These Terms are governed by the laws of the State of California, without regard
        to its conflict-of-law principles.  
        Any disputes shall be resolved in the courts located in California, USA.
      </p>

      <h3>13. Changes to These Terms</h3>
      <p>
        We may update these Terms from time to time. When we do, we’ll notify registered
        users by email and update the “Last updated” date below.
        Continued use of the Service after an update means you accept the revised Terms.
      </p>

      <h3>14. Contact</h3>
      <p>
        For any questions about these Terms, please contact us at{" "}
        <a href="mailto:contact@gfnavigator.com">contact@gfnavigator.com</a>.
      </p>

      <p className="help">Last updated: November 2025</p>
    </div>
  );
}
